import { render, staticRenderFns } from "./RepresentationRequestList.vue?vue&type=template&id=475ed35a"
import script from "./RepresentationRequestList.vue?vue&type=script&lang=js"
export * from "./RepresentationRequestList.vue?vue&type=script&lang=js"
import style0 from "./RepresentationRequestList.vue?vue&type=style&index=0&id=475ed35a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports